import type { FC } from 'react';

import type { ChipViewProps } from './types';
import { Chip2d } from './variants/2d/Chip2d';
import { Chip3d } from './variants/3d/Chip3d';

/**
 * # Chip
 *
 * ### Chip component itself is **not intended to be used in game code**. It is used by `ChipConnected` component.
 *
 * Chip is a component used to represent a single chip. Can be configured to be of any size, has 8 weight (color) variants.
 *
 * Uses specific limited version of Montserrat font, called `Montserrat Chip`, that contains only digits and some characters,
 * including `K`, `M`, `B`, `T`, `+`, `.`, `,`.
 *
 * Value of the chip is dynamically scaled according to the documentation and the size of the chip
 * https://www.figma.com/design/DKpTzACEQvqej7LsUat4S5/1.--Design-system?node-id=22-238574&m=dev&focus-id=28344-83379
 *
 * */
export const Chip: FC<ChipViewProps> = (props) => {
  const { tilt = 0, rotate = 0 } = props;

  if (tilt > 0 || rotate > 0) {
    return <Chip3d {...props} />;
  }

  return <Chip2d {...props} />;
};
